export const IM_LogObjectTR={
LoObID:{en:'LoObID',cs:'LoObID',dataType:'string',required:true},
LoObName:{en:'LoObName',cs:'LoObName',dataType:'string',required:true}
}